import { List } from "@mui/material";
import type { TagItem } from "src/queries/tags/tags.types";
import TagMenuItem from "../../../TagMenuItem/TagMenuItem";

interface TagFamilyListProps {
  tags: TagItem[];
  selectedTagIds: Set<number>;
  onTagToggle: (tagId: number) => void;
  searchText: string;
}

export default function TagFamilyList({
  tags,
  selectedTagIds,
  onTagToggle,
  searchText,
}: TagFamilyListProps) {
  return (
    <List component="div" disablePadding>
      {tags.map((tag) => (
        <TagMenuItem
          key={tag.tag_id}
          tag={tag}
          isStandalone={false}
          isSelected={selectedTagIds.has(tag.tag_id)}
          onToggle={onTagToggle}
          searchText={searchText}
        />
      ))}
    </List>
  );
}
